import { EventEmitter } from "events"
import dispatcher from "../dispatcher"
import * as utils from "../helpers/utils"
import { IUserDocument, ISupervisorExplicitJobData, ESuepervisorJobExplicitTypes, IAccountManagerUserDocument, ELanguage } from "../models"
import AccountStore from "./AccountStore"
import moment from "moment"

class AuthenticationStore extends EventEmitter {
	crossProxyError: boolean = false
	loggingIn: boolean = false
	loginFail: boolean = false
	SentRequestResetPassword: boolean = false
	PasswordUpdated: boolean = false
	LoggedInUser: IUserDocument = null
	LoggedInAccountManagerUser: IAccountManagerUserDocument = null
	CookieUserId = utils.getCookie("userId")
	SSOParam = utils.getNonLocalStorageCookie("sso-username")
	CookieSSOLogoutUrl = utils.getNonLocalStorageCookie("sso-logout-url")
	CookieAccountId = utils.getCookie("accountId")
	SpecialPermission = {
		GlobalAdmin: "GLOBAL_ADMIN",
		SelfService: "SELF_SERVICE",
		AccountManager: "ACCOUNT_MANAGER"
	}
	LoggedInUserTypes = {
		AccountAdmin: "ADMIN",
		AccountUser: "USER",
		Employee: "EMPLOYEE"
	}
	Permissions = {
		Account: {
			AccountAdmin: "ACCOUNT_ADMIN",
			ViewFullHierarchy: "VIEW_FULL_HIERARCHY",
			EditHierarchy: "EDIT_HIERARCHY",
			ViewRates: "VIEW_RATES",
			EditRates: "EDIT_RATES",
			ViewScheduledJobs: "VIEW_SCHEDULED_JOBS",
			ExportFailedPunches: "EXPORT_3RD_PARTY_PUNCHES",
			ViewHierarchyTab: "VIEW_HIERARCHY_TAB",
			ViewTimeReports: "VIEW_TIME_REPORTS",
		},
		Import: {
			ImportPunchCSV: "IMPORT_PUNCH_CSV",
			ImportExpenseTimeCSV: "IMPORT_EXPENSE_TIME_CSV",
			ImportExpenseAmountCSV: "IMPORT_EXPENSE_AMOUNT_CSV",
			ImportEmployeesCSV: "IMPORT_EMPLOYEES_CSV",
			ImportJobsCSV: "IMPORT_JOBS_CSV",
			ImportScheduleCSV: "IMPORT_SCHEDULE_CSV"
		},
		Employees: {
			AllowSelfEmpEdit: "ALLOW_SELF_EMP_EDIT",
			ViewEmployees: "VIEW_EMPLOYEES",
			EditEmployees: "EDIT_EMPLOYEES",
			AddEmployees: "ADD_EMPLOYEES",
			DeleteEmployees: "DELETE_EMPLOYEES",
			ViewCustomEmployeeFields: "VIEW_CUSTOM_EMPLOYEE_FIELDS",
			EditCustomEmployeeFields: "EDIT_CUSTOM_EMPLOYEE_FIELDS",
			CanAddNonDirectReportEmployees: "CAN_ADD_NON_DIRECT_REPORT_EMPLOYEES",
			EditProfilePic: "EDIT_PROFILE_PIC",
			EditFaceSpaces: "EDIT_FACE_SPACES",
			ViewFile: "VIEW_FILES",
			AddFile: "ADD_FILES",
			DeleteFile: "DELETE_FILE",
		},
		SupervisorDirectReport: {
			ViewAllEmployees: "VIEW_ALL_EMPLOYEES"
		},
		PunchRecords: {
			ViewRecords: "VIEW_RECORDS",
			EditExceptions: "EDIT_EXCEPTIONS",
			EditSuspense: "EDIT_SUSPENSE",
		},
		Timecards: {
			ViewTimecards: "VIEW_TIMECARDS",
			EditTimecards: "EDIT_TIMECARDS",
			ApproveTimecards: "APPROVE_TIMECARDS",
			PriorPeriodAdjustments: "PRIOR_PERIOD_ADJUSTMENTS",
			PriorPeriodAdjustmentsExportEdits: "PRIOR_PERIOD_ADJUSTMENTS_EXPORT_EDITS",
			GlobalPunchAdd: "GLOBAL_PUNCH_ADD",
			GlobalPunchEdit: "GLOBAL_PUNCH_EDIT",
			PunchRuleOverride: "PUNCH_RULE_OVERRIDE"
		},
		Payroll: {
			ViewPayroll: "VIEW_PAYROLL",
			LockPayroll: "LOCK_PAYROLL",
			ClosePayroll: "CLOSE_PAYROLL",
			ExportPayroll: "EXPORT_PAYROLL",
			ViewPayrollByJob: "VIEW_PAYROLL_BY_JOB",
			EditPayrollAfterLock: "EDIT_PAYROLL_AFTER_LOCK",
		},
		Devices: {
			ViewAllDevices: "VIEW_ALL_DEVICES",
			EditAllDevices: "EDIT_ALL_DEVICES",
			AddAllDevices: "ADD_ALL_DEVICES",
			DeleteAllDevices: "DELETE_All_DEVICES",
			InitDevices: "INIT_DEVICES",
			ViewHierarchyDevices: "VIEW_HIERARCHY_DEVICES",
			EditHierarchyDevices: "EDIT_HIERARCHY_DEVICES",
			AddHierarchyDevices: "ADD_HIERARCHY_DEVICES",
			DeleteHierarchyDevices: "DELETE_HIERARCHY_DEVICES",
			ViewUserDevices: "VIEW_USER_DEVICES",
			EditUserDevices: "EDIT_USER_DEVICES",
			AddUserDevices: "ADD_USER_DEVICES",
			DeleteUserDevices: "DELETE_USER_DEVICES",
			ViewJobDevices: "VIEW_JOB_DEVICES",
			EditJobDevices: "EDIT_JOB_DEVICES",
			AddJobDevices: "ADD_JOB_DEVICES",
			DeleteJobDevices: "DELETE_JOB_DEVICES",
		},
		Equipment: {
			ViewEquipment: "VIEW_EQUIPMENT",
			EditEquipment: "EDIT_EQUIPMENT",
			AddEquipment: "ADD_EQUIPMENT",
			DeleteEquipment: "DELETE_EQUIPMENT"
		},
		Accrual: {
			ViewAccrual: "VIEW_ACCRUAL",
			EditAccrual: "EDIT_ACCRUAL",
			AddAccrual: "ADD_ACCRUAL",
			DeleteAccrual: "DELETE_ACCRUAL",
			ViewUserAccrual: "VIEW_USER_ACCRUAL",
			EditUserAccrual: "EDIT_USER_ACCRUAL",
			AddUserAccrual: "ADD_USER_ACCRUAL",
			DeleteUserAccrual: "DELETE_USER_ACCRUAL",
		},
		LeaveTracking: {
			AllowSupervisorToApproveDenyOwnLeaveRequests: "ALLOW_SUPERVISOR_TO_APPROVE_DENY_OWN_LEAVE_REQUESTS",
			ViewLeaveTracking: "VIEW_LEAVE_TRACKING",
			EditLeaveTracking: "EDIT_LEAVE_TRACKING",
			AddLeaveTracking: "ADD_LEAVE_TRACKING",
			DeleteLeaveTracking: "DELETE_LEAVE_TRACKING",
			ViewUserLeaveTracking: "VIEW_USER_LEAVE_TRACKING",
			EditUserLeaveTracking: "EDIT_USER_LEAVE_TRACKING",
			AddUserLeaveTracking: "ADD_USER_LEAVE_TRACKING",
			DeleteUserLeaveTracking: "DELETE_USER_LEAVE_TRACKING"
		},
		Schedule: {
			ViewAccountSchedule: "VIEW_ACCOUNT_SCHEDULE",
			EditAccountSchedule: "EDIT_ACCOUNT_SCHEDULE",
			AddAccountSchedule: "ADD_ACCOUNT_SCHEDULE",
			DeleteAccountSchedule: "DELETE_ACCOUNT_SCHEDULE",
			ViewSchedule: "VIEW_SCHEDULE",
			EditSchedule: "EDIT_SCHEDULE",
			AddSchedule: "ADD_SCHEDULE",
			DeleteSchedule: "DELETE_SCHEDULE",
			ViewUserSchedule: "VIEW_USER_SCHEDULE",
			EditUserSchedule: "EDIT_USER_SCHEDULE"
		},
		Expense: {
			ViewEmployeeExpense: "VIEW_EMPLOYEE_EXPENSE",
			EditEmployeeExpense: "EDIT_EMPLOYEE_EXPENSE",
			AddEmployeeExpense: "ADD_EMPLOYEE_EXPENSE",
			DeleteEmployeeExpense: "DELETE_EMPLOYEE_EXPENSE",
			ApproveEmployeeExpense: "APPROVE_EMPLOYEE_EXPENSE",
			ViewPayrollExpense: "VIEW_PAYROLL_EXPENSE",
			LockPayrollExpense: "LOCK_PAYROLL_EXPENSE",
			ClosePayrollExpense: "CLOSE_PAYROLL_EXPENSE",
			ExportPayrollExpense: "EXPORT_PAYROLL_EXPENSE"
		},
		Jobs: {
			ViewJobs: "VIEW_JOBS",
			AddJobs: "ADD_JOBS",
			EditJobs: "EDIT_JOBS",
			DeleteJobs: "DELETE_JOBS",
			EditCustomJobFields: "EDIT_CUSTOM_JOB_FIELDS",
			EditJobClientSelection: "EDIT_JOB_CLIENT_SELECTION",
		},
		JobTabs: {
			ViewJobAttributes: "VIEW_JOB_ATTRIBUTES",
			ViewJobWorkerPool: "VIEW_JOB_WORKER_POOL",
			ViewAssignedEmployee: "VIEW_ASSIGNED_EMPLOYESS",
			ViewJobTimecard: "VIEW_JOB_TIMECARD",
			ViewJobSchedule: "VIEW_JOB_SCHEDULE",
			ViewJobLocation: "VIEW_JOB_LOCATION",
			EditJobLocation: "EDIT_JOB_LOCATION",
			ViewPhases: "VIEW_PHASES",
			ViewJobPositions: "VIEW_JOB_POSITIONS",
			ViewJobExpenses: "VIEW_JOB_EXPENSES",
			ViewJobBudget: "VIEW_JOB_BUDGET",
			EditJobBudget: "EDIT_JOB_BUDGET",
			ViewJobPhotos: "VIEW_JOB_PHOTOS",
			ViewJobSettings: "VIEW_JOB_SETTINGS"
		},
		Clients: {
			ViewClients: "VIEW_CLIENTS",
			AddClients: "ADD_CLIENTS",
			EditClients: "EDIT_CLIENTS",
			DeleteClients: "DELETE_CLIENTS",
			EditCustomClientFields: "EDIT_CUSTOM_CLIENT_FIELDS",
		},
		Rewards: {
			ViewRewards: "VIEW_REWARDS",
			AddRewards: "ADD_REWARDS",
			EditRewards: "EDIT_REWARDS",
			DeleteRewards: "DELETE_REWARDS"
		},
		Trends: {
			ViewTrends: "VIEW_TRENDS",
		},
		HRSettingsPipelines: {
			View: "VIEW_ACCOUNT_SETTINGS_PIPELINES",
			Add: "ADD_ACCOUNT_SETTINGS_PIPELINES",
			Delete: "DELETE_ACCOUNT_SETTINGS_PIPELINES",
			Edit: "EDIT_ACCOUNT_SETTINGS_PIPELINES"
		},
		HRSettingsBadges: {
			View: "VIEW_ACCOUNT_SETTINGS_BADGES",
			Add: "ADD_ACCOUNT_SETTINGS_BADGES",
			Delete: "DELETE_ACCOUNT_SETTINGS_BADGES",
			Edit: "EDIT_ACCOUNT_SETTINGS_BADGES"
		},
		HRSettingsCredentials: {
			View: "VIEW_ACCOUNT_SETTINGS_CREDENTIALS",
			Add: "ADD_ACCOUNT_SETTINGS_CREDENTIALS",
			Delete: "DELETE_ACCOUNT_SETTINGS_CREDENTIALS",
			Edit: "EDIT_ACCOUNT_SETTINGS_CREDENTIALS"
		},
		HRSettingsFiles: {
			View: "VIEW_ACCOUNT_SETTINGS_FILES",
			Add: "ADD_ACCOUNT_SETTINGS_FILES",
			Delete: "DELETE_ACCOUNT_SETTINGS_FILES",
			Edit: "EDIT_ACCOUNT_SETTINGS_FILES"
		},
		HRSettingsUsers: {
			View: "VIEW_ACCOUNT_SETTINGS_USERS",
			Add: "ADD_ACCOUNT_SETTINGS_USERS",
			Edit: "EDIT_ACCOUNT_SETTINGS_USERS",
			Delete: "DELETE_ACCOUNT_SETTINGS_USERS"
		},
		HRSettingsChecklistsNotes: {
			View: "VIEW_ACCOUNT_SETTINGS_NOTES_CHECKLISTS",
			Add: "ADD_ACCOUNT_SETTINGS_NOTES_CHECKLISTS",
			Edit: "EDIT_ACCOUNT_SETTINGS_NOTES_CHECKLISTS",
			Delete: "DELETE_ACCOUNT_SETTINGS_NOTES_CHECKLISTS"
		},
		HRSettingsJobs: {
			View: "VIEW_ACCOUNT_SETTINGS_HR_JOBS",
			Add: "ADD_ACCOUNT_SETTINGS_HR_JOBS",
			Edit: "EDIT_ACCOUNT_SETTINGS_HR_JOBS",
			Delete: "DELETE_ACCOUNT_SETTINGS_HR_JOBS"
		},
		HRSettingsIntegrations: {
			View: "VIEW_ACCOUNT_SETTINGS_INTEGRATIONS",
			Add: "ADD_ACCOUNT_SETTINGS_INTEGRATIONS",
			Edit: "EDIT_ACCOUNT_SETTINGS_INTEGRATIONS",
			Delete: "DELETE_ACCOUNT_SETTINGS_INTEGRATIONS"
		},
		HRAccessPipelines: {
			View: "VIEW_PIPELINES",
			Add: "ADD_PIPELINES",
			Delete: "DELETE_PIPELINES",
			Edit: "EDIT_PIPELINES",
		},
		HRAccessPeople: {
			View: "VIEW_HR_PEOPLE",
			Add: "ADD_HR_PEOPLE",
			Delete: "DELETE_HR_PEOPLE",
			Edit: "EDIT_HR_PEOPLE"
		},
		HRAccessCredentials: {
			View: "VIEW_CREDENTIALS",
			Add: "ADD_CREDENTIALS",
			Delete: "DELETE_CREDENTIALS",
			Edit: "EDIT_CREDENTIALS",
		},
		HRAccessDemographics: {
			View: "VIEW_DEMOGRAPHICS",
			Edit: "EDIT_DEMOGRAPHICS",
		},
		HRAccessGovernmentId: {
			View: "VIEW_GOVERNMENT_ID",
			Edit: "EDIT_GOVERNMENT_ID",
		},
		HRAccessContactInfo: {
			View: "VIEW_CONTACT_INFO",
			Edit: "EDIT_CONTACT_INFO",
		},
		HRAccessLanguageEthnicity: {
			View: "VIEW_LANGUAGE_ETHNICITY",
			Edit: "EDIT_LANGUAGE_ETHNICITY",
		},
		HRBankInfo: {
			View: "VIEW_BANK_INFO",
			Add: "ADD_BANK_INFO",
			Edit: "EDIT_BANK_INFO",
			Delete: "DELETE_BANK_INFO",
		},
		HRPayCompensation: {
			View: "VIEW_PAY_COMPENSATION",
			ViewSalary: "VIEW_SALARY_PAY_COMPENSATION",
			ViewHourly: "VIEW_HOURLY_PAY_COMPENSATION",
			Add: "ADD_PAY_COMPENSATION",
			Edit: "EDIT_PAY_COMPENSATION",
			Delete: "DELETE_PAY_COMPENSATION",
		},
		HRTerminationNotes: {
			"Edit": "EDIT_TERMINATION_NOTE"
		},
		HRHireTerminationAudits: {
			Delete: "DELETE_TERMINATION_AUDITS",
		},
		HRAccessSpecialties: {
			View: "VIEW_EMPLOYEE_SPECIALTIES",
			Add: "ADD_EMPLOYEE_SPECIALTIES",
			Edit: "EDIT_EMPLOYEE_SPECIALTIES",
			Delete: "DELETE_EMPLOYEE_SPECIALTIES",
		},
		HRAccessEmployeeFiles: {
			View: "VIEW_EMPLOYEE_FILES",
			Add: "ADD_EMPLOYEE_FILES",
			Edit: "EDIT_EMPLOYEE_FILES",
			Delete: "DELETE_EMPLOYEE_FILES",
			DeleteVersion: "DELETE_EMPLOYEE_FILE_VERSION"
		},
		HRAccessWorkHistory: {
			View: "VIEW_EMPLOYEE_WORK_HISTORY",
			Add: "ADD_EMPLOYEE_WORK_HISTORY",
			Edit: "EDIT_EMPLOYEE_WORK_HISTORY",
			Delete: "DELETE_EMPLOYEE_WORK_HISTORY",
		},
		HRAccessEducation: {
			View: "VIEW_EMPLOYEE_EDUCATION",
			Add: "ADD_EMPLOYEE_EDUCATION",
			Edit: "EDIT_EMPLOYEE_EDUCATION",
			Delete: "DELETE_EMPLOYEE_EDUCATION",
		},
		HRAccessEmployeeCredentials: {
			View: "VIEW_EMPLOYEE_CREDENTIALS",
			Add: "ADD_EMPLOYEE_CREDENTIALS",
			Edit: "EDIT_EMPLOYEE_CREDENTIALS",
			Delete: "DELETE_EMPLOYEE_CREDENTIALS",
		},
		HRAccessEmployeeChecklists: {
			View: "VIEW_EMPLOYEE_CHECKLISTS",
			Add: "ADD_EMPLOYEE_CHECKLISTS",
			Edit: "EDIT_EMPLOYEE_CHECKLISTS",
			Delete: "DELETE_EMPLOYEE_CHECKLISTS",
		},
		HRAccessEmployeeReferences: {
			View: "VIEW_EMPLOYEE_REFERENCES",
			Add: "ADD_EMPLOYEE_REFERENCES",
			Edit: "EDIT_EMPLOYEE_REFERENCES",
			Delete: "DELETE_EMPLOYEE_REFERENCES",
		},
		HRAccessEmployeeBadges: {
			View: "VIEW_EMPLOYEE_BADGES",
			Add: "ADD_EMPLOYEE_BADGES",
			Edit: "EDIT_EMPLOYEE_BADGES",
			Delete: "DELETE_EMPLOYEE_BADGES",
		},
		HRAccessEmployeeRewards: {
			View: "VIEW_EMPLOYEE_REWARDS",
			Add: "ADD_EMPLOYEE_REWARDS",
			Edit: "EDIT_EMPLOYEE_REWARDS",
			Delete: "DELETE_EMPLOYEE_REWARDS",
		},
		HRAccessEmployeeAttributes: {
			View: "VIEW_EMPLOYEE_ATTRIBUTES",
		},
		HRAccessEmployee: {
			ChangeStatusViaPipeline: "ALLOW_CHANGE_STATUS_VIA_PIPELINE",
			ChangeStatusViaProfilePage: "ALLOW_CHANGE_STATUS_VIA_PROFILE_PAGE",
			ChangeEmail: "ALLOW_CHANGE_EMAIL",
			ChangeMobile: "ALLOW_CHANGE_MOBILE",
			VerifyFilesMissingPrerequisites: "VERIFY_FILES_MISSING_PREREQUISITES",
			Rehire: "ALLOW_REHIRE"
		},
		HRAccessATS: {
			View: "VIEW_JOB_POSTING",
			Add: "ADD_JOB_POSTING",
			Edit: "EDIT_JOB_POSTING",
			Delete: "DELETE_JOB_POSTING",
			AllowAccessToAllJobPostings: "ALLOW_ACCESS_TO_ALL_JOB_POSTINGS",
		},
		HRAccessMessageCenter: {
			View: "VIEW_MOBILIZE",
			Delete: "DELETE_MESSAGE"
		},
		HRAccessCampaigns: {
			View: "VIEW_CAMPAIGNS_ANALYTICS",
			Add: "ADD_CAMPAIGNS",
			Edit: "EDIT_CAMPAIGNS",
			Delete: "DELETE_CAMPAIGNS"
		}
	}

	AccountManagerUserPermissions = {
		Account: {
			ViewAacountManagerUsersTab: "VIEW_ACCOUNT_MANAGER_USERS",
			ViewSystemTab: "VIEW_SYSTEM_INFO"
		},
		Clients: {
			ViewClients: "VIEW_ACCOUNT_MANAGER_CLIENTS",
			EditAccountManagerClientDetails: "EDIT_ACCOUNT_MANAGER_CLIENTS_DETAILS",
			CreateClientAccount: "ADD_ACCOUNT_MANAGER_CLIENTS",
			EnterClientAccount: "ENTER_CLIENT_ACCOUNTS",
			AssignPotentialClientRelationshipManager: "ASSIGN_POTENTIAL_CLIENT_RELATIONSHIP_MANAGER",
			AccountScheduledJob: "ACCOUNT_SCHEDULED_JOB",
			AccountFeatureSetting: "ACCOUNT_FEATURE_SETTING",
		}
	}

	dispatcherIndex

	constructor() {
		super()
		this.setMaxListeners(0)
	}

	sentRequestResetPassword() {
		this.SentRequestResetPassword = true
		this.emit("change")
	}

	getSentRequestResetPassword() {
		return this.SentRequestResetPassword
	}

	passwordUpdated() {
		this.PasswordUpdated = true
		this.SentRequestResetPassword = false
		this.emit("change")
	}

	getPasswordUpdated() {
		return this.PasswordUpdated
	}

	isLoggedIn() {
		return this.LoggedInUser != null
	}

	loggedIn() {
		return this.LoggedInUser !== null
	}

	getLoggedInUser() {
		return this.LoggedInUser
	}

	getLoggedInAccountManagerUser() {
		return this.LoggedInAccountManagerUser
	}

	getLoggedInUserLanguage() {
		return this.LoggedInUser.Language
	}

	getCookieUserId() {
		return this.CookieUserId
	}

	getCookieSSOLogoutUrl() {
		return this.CookieSSOLogoutUrl
	}

	deleteCookieSSOLogoutUrl() {
		utils.deleteCookie("sso-logout-url")
	}

	deleteCookieAuth() {
		utils.deleteCookie(".ASPXAUTH")
	}

	getCookieAccountId() {
		return this.CookieAccountId
	}

	logout() {
		this.SentRequestResetPassword = false
		this.PasswordUpdated = false
		this.LoggedInUser = null
		this.LoggedInAccountManagerUser = null
		this.CookieUserId = null
		this.CookieAccountId = null
		this.clearProxy()
		this.clearIsAccountManager()
		AccountStore.clear();

		this.emit("change")
	}

	recieveAuthData(authData) {
		this.SentRequestResetPassword = false
		this.PasswordUpdated = false
		this.loginFail = false
		this.LoggedInUser = authData.User
		this.CookieUserId = authData.User.Id
		this.CookieAccountId = authData.Account.Id

		if (!this.getIsProxy()) {
			this.setIsAccountManager(authData.AccountManager)
		}
		this.LoggedInAccountManagerUser = authData.AccountManagerUser

		this.setLanguageForMoment()
		this.emit("change")
	}

	setLanguageForMoment() {
		this.LoggedInUser && this.LoggedInUser.Language === ELanguage.Español &&
			moment.locale("es")
	}

	setIsAccountManager(value) {
		sessionStorage.setItem("findd_account_manager", value)
	}

	getIsAccountManager() {
		return sessionStorage.getItem("findd_account_manager") === "true"
	}

	getIsProxy() {
		return localStorage.getItem("findd_proxy") !== null
	}

	clearProxy() {
		localStorage.removeItem("findd_proxy")
	}

	clearIsAccountManager() {
		sessionStorage.removeItem("findd_account_manager")
	}

	isCrossProxyError() {
		return this.crossProxyError
	}

	setCrossProxyError() {
		this.crossProxyError = true
		this.emit("change")
	}

	updateLoggedInUserData(loggedInUser) {
		this.LoggedInUser = loggedInUser
		this.setLanguageForMoment()
		this.emit("change")
	}

	updateLoggedInAccountManagerUserData(loggedInAccountManagerUser: IAccountManagerUserDocument) {
		this.LoggedInAccountManagerUser = loggedInAccountManagerUser
	}

	checkSupervisorAllowPayrollActions() {
		const supervisorJobExplicitData: ISupervisorExplicitJobData = {
			AccountUser: true,
			JobExplicitTypes: this.LoggedInUser.JobExplicitTypes,
			ExplicitJobIds: this.LoggedInUser.ExplicitJobIds
		}
		let includeJobIds = [], excludeJobIds = []
		if (supervisorJobExplicitData != null && supervisorJobExplicitData.JobExplicitTypes != ESuepervisorJobExplicitTypes.All) {
			if (supervisorJobExplicitData.JobExplicitTypes == ESuepervisorJobExplicitTypes.Include) {
				includeJobIds = supervisorJobExplicitData.ExplicitJobIds
			}
			if (supervisorJobExplicitData.JobExplicitTypes == ESuepervisorJobExplicitTypes.Exclude) {
				excludeJobIds = supervisorJobExplicitData.ExplicitJobIds
			}
		}
		return !((includeJobIds && includeJobIds.length > 0) || (excludeJobIds && excludeJobIds.length > 0))
	}

	handleActions(action) {
		switch (action.type) {
			case "LOGOUT": {
				this.logout()
				break
			}
			case "RECEIVE_AUTH_DATA": {
				this.recieveAuthData(action.authData)
				break
			}
			case "SENT_REQUEST_RESET_PASSWORD": {
				this.sentRequestResetPassword()
				break
			}
			case "PASSWORD_UPDATED": {
				this.passwordUpdated()
				break
			}
			case "UPDAE_LOGGED_IN_USER_DATA": {
				this.updateLoggedInUserData(action.data)
				break
			}
		}
	}
}

const authenticationStore = new AuthenticationStore()
authenticationStore.dispatcherIndex = dispatcher.register(authenticationStore.handleActions.bind(authenticationStore))

export default authenticationStore
